import React, { ReactElement } from 'react'
import { TeaserTypes } from '../../TeaserInterface'
import VideoLabelProps from '../../../BaseComponents/Labels/Video/VideoLabelProps'
import SmallTeaserVideoImage from './Video'
import SmallTeaserGalleryImage from './Gallery'
import SmallTeaserArticleImage from './Article'

type SmallTeaserImageProps = VideoLabelProps & {
    type: TeaserTypes
    imageUrl?: string
    alt?: string
}

const SmallTeaserImage = ({
    imageUrl,
    alt,
    type,
    teaserIcon,
}: SmallTeaserImageProps): ReactElement => {
    const commonProps = {
        imageUrl,
        alt,
        teaserIcon,
    }
    if (type === 'VIDEO') {
        return <SmallTeaserVideoImage {...commonProps} />
    } else if (type === 'GALLERY') {
        return <SmallTeaserGalleryImage {...commonProps} />
    }
    return <SmallTeaserArticleImage {...commonProps} />
}

export default SmallTeaserImage
